import * as React from 'react';
import cx from 'classnames';
import styles from './Loader.css';
export default function Loader(props) {
    return (<div className={cx(styles['loader'], props.className)}>
			<svg className={styles['circular']} viewBox="25 25 50 50">
				<circle stroke={props.stroke || '#0057e7'} className={styles['path']} cx="50" cy="50" r={props.radius || 20} fill="none" strokeWidth={props.width || 5} strokeMiterlimit="10"/>
			</svg>
		</div>);
}
